/**
 * Repolished collection filters — full page navigation.
 * Flex z__jsCollection.js AJAX expects .collection-matrix__wrapper (old Flex markup).
 * Our Lovable grid does not use that, so AJAX empties the product area and leaves
 * the header out of sync. Navigate instead so header + products update together.
 */
(function () {
  function onFilterChange(event) {
    var el = event.target;
    if (!el || !el.closest) return;
    if (!el.closest('.repolished-collection-products')) return;

    if (el.id === 'tag_filter' && el.value) {
      window.location.assign(el.value);
      return;
    }

    if (el.id === 'sort-by' && el.value) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
  }

  document.addEventListener('change', onFilterChange);
})();
